import {Action, Selector, State, StateContext} from '@ngxs/store';
import {DashboardStateModel, defaultState} from './dashboard-state.model';
import {ToggleDashboardFeature} from './actions';
import {Injectable} from '@angular/core';

@State<DashboardStateModel>({
  name: 'dashboard',
  defaults: defaultState
})
@Injectable()
export class DashboardState {

  @Selector()
  static getStates(state: DashboardStateModel) {
    return state;
  }

  @Action(ToggleDashboardFeature)
  toggleFeature({patchState}: StateContext<DashboardStateModel>, {features}: ToggleDashboardFeature) {
    patchState(features);
  }
}
